import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"

export default class extends Controller {
  static targets = ["input", "clear"]
  static values = {
    altFormat: String,
    dateFormat: { type: String, default: "Y-m-d" }
  }

  connect() {
    const options = {
      altInput: true,
      altFormat: this.altFormat,
      dateFormat: this.dateFormatValue,
      disableMobile: true,
      monthSelectorType: "static",
      onChange: () => this.syncClearState(),
      onReady: (_selectedDates, _dateStr, instance) => {
        instance.altInput?.classList.add("date-picker-field__alt-input")
        this.syncClearState()
      }
    }

    if (this.locale) {
      options.locale = this.locale
    }

    this.picker = flatpickr(this.inputTarget, options)
    this.syncClearState()
  }

  disconnect() {
    this.picker?.destroy()
  }

  clear(event) {
    event.preventDefault()

    this.picker?.clear()
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.syncClearState()
  }

  open(event) {
    event.preventDefault()
    this.picker?.open()
  }

  syncClearState() {
    if (!this.hasClearTarget) return

    this.clearTarget.hidden = this.inputTarget.value.length === 0
  }

  get locale() {
    return this.localeCode.startsWith("fr") ? French : null
  }

  get altFormat() {
    return this.hasAltFormatValue ? this.altFormatValue : (this.localeCode.startsWith("fr") ? "j F Y" : "M j, Y")
  }

  get localeCode() {
    return document.documentElement.lang?.toLowerCase() || "en"
  }
}
